// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '0f0fc26',
    builtAt: '2026-09-16T09:24:27.119Z',
} as const;
